import React, { useState, useEffect } from "react";
import { FaBars, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import InputMask from 'react-input-mask';
import { Checkbox, FormControlLabel, TextField, Button, IconButton, Typography } from '@mui/material';
import Sidebar from '../Sidebar';
import './styles.css';
import api from "../../Services/api";

export const Configuracao = () => {
    const navigate = useNavigate();
    const [idConfiguracao, setIdConfiguracao] = useState(0);
    const [sidebar, setSidebar] = useState(false);
    const [destinatario, setDestinatario] = useState("");
    const [assunto, setAssunto] = useState("");
    const [nomeempresa, setNomeEmpresa] = useState("");
    const [copia, setCopia] = useState("");
    const [razao, setRazao] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [automatico, setAutomatico] = useState(0);

    useEffect(() => {
        BuscaConfiguracao();
        //eslint-disable-next-line
    }, []);

    let webtoken = localStorage.getItem("token");

    const SendAltCad = (e) => {
        e.preventDefault();
        CadastroConfig();
    }

    async function CadastroConfig() {
        if (nomeempresa !== "" && destinatario !== "" && assunto !== "" && razao !== "" && cnpj !== "") {
            api.defaults.headers.post = { 'Content-Type': 'application/json' };
            api.defaults.headers.common = { 'x-access-token': webtoken };
            let cadastro;

            if (idConfiguracao === 0) {
                cadastro = await NewConfig();
            } else {
                cadastro = await EnviaConfig();
            }

            if (cadastro.status === 200) {
                alert('As Configuracoes foram salvas com sucesso!');
                window.location.reload();
            } else {
                alert('Falha ao salvar Configuracoes. tente novamente');
            }
        } else {
            alert('Antenção! Preencha todos os campos');
        }
    }

    async function NewConfig() {
        let response = await api.post(
            '/configuracao/cadastro/', {
                'copia': copia,
                'assunto': assunto,
                'destinatario': destinatario,
                'nomeempresa': nomeempresa,
                'razao': razao,
                'cnpj': cnpj,
                'automatico': automatico
            }
        );
        return response;
    }

    async function EnviaConfig() {
        let response = await api.put(
            '/configuracao/update/', {
                'idConfiguracao': idConfiguracao,
                'copia': copia,
                'assunto': assunto,
                'destinatario': destinatario,
                'nomeempresa': nomeempresa,
                'razao': razao,
                'cnpj': cnpj,
                'automatico': automatico
            }
        );
        return response;
    }

    async function gravaLocalstorage() {
        localStorage.removeItem("idConfiguracao");
        localStorage.removeItem("remetente");
        localStorage.removeItem("destinatario");
        localStorage.removeItem("assunto");
        localStorage.removeItem("nomeempresa");
        localStorage.removeItem("copia");
        localStorage.removeItem("razao");
        localStorage.removeItem("cnpj");
        localStorage.removeItem("automatico");
    }

    async function BuscaConfiguracao() {
        api.defaults.headers.post = { 'Content-Type': 'application/json' };
        api.defaults.headers.common = { 'x-access-token': webtoken };
        let configuracao = await buscaConfig();

        if (configuracao) {
            await gravaLocalstorage();
            if (configuracao.id >= 0) {
                setIdConfiguracao(configuracao.id);
                setDestinatario(configuracao.destinatario);
                setAssunto(configuracao.assunto);
                setNomeEmpresa(configuracao.nomeEmpresa);
                setCopia(configuracao.copia);
                setRazao(configuracao.razao);
                setCnpj(configuracao.cnpj);
                setAutomatico(configuracao.automatico);

                localStorage.setItem("idConfiguracao", configuracao.id);
                localStorage.setItem("destinatario", configuracao.destinatario);
                localStorage.setItem("assunto", configuracao.assunto);
                localStorage.setItem("nomeempresa", configuracao.nomeEmpresa);
                localStorage.setItem("copia", configuracao.copia);
                localStorage.setItem("razao", configuracao.razao);
                localStorage.setItem("cnpj", configuracao.cnpj);
                localStorage.setItem("automativo", configuracao.automatico);
            }
        } else {
            alert('Falha ao Buscar Configuracoes. tente novamente');
        }
    }

    async function buscaConfig() {
        let response = await api.get('/configuracao/');
        return response.data;
    }
    
    const handleChangeAutomatico = (event) => {
        setAutomatico(event.target.checked);
    };

    return (
        <>
            <div className="configuracao-container">
                <div className="configuracao-header">
                    <FaBars className="menu-icon" onClick={() => setSidebar(true)} />
                    <Sidebar active={sidebar} setActive={setSidebar} />
                    <IconButton onClick={() => navigate(-1)} style={{ marginLeft: 'auto' }}>
                        <FaArrowLeft />
                        <span style={{ marginLeft: '8px' }}>Voltar</span>
                    </IconButton>
                </div>

                <main className="configuracao-main">
                    <fieldset>
                        <legend>
                            <Typography variant="h4">Configurações</Typography>
                        </legend>
                        <form onSubmit={SendAltCad} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <TextField
                                label="Nome da Empresa"
                                variant="outlined"
                                value={nomeempresa}
                                onChange={(e) => setNomeEmpresa(e.target.value)}
                            />
                            <TextField
                                label="Razão Social"
                                variant="outlined"
                                value={razao}
                                onChange={(e) => setRazao(e.target.value)}
                            />
                            <InputMask
                                mask="99.999.999/9999-99"
                                value={cnpj}
                                onChange={(e) => setCnpj(e.target.value)}
                            >
                                {() => <TextField label="CNPJ" variant="outlined" />}
                            </InputMask>
                            <TextField
                                label="Assunto"
                                variant="outlined"
                                value={assunto}
                                onChange={(e) => setAssunto(e.target.value)}
                            />
                            <TextField
                                label="Destinatário"
                                variant="outlined"
                                value={destinatario}
                                onChange={(e) => setDestinatario(e.target.value)}
                            />
                            <TextField
                                label="Cópia para"
                                variant="outlined"
                                value={copia}
                                onChange={(e) => setCopia(e.target.value)}
                            />
                        
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={automatico}
                                    onChange={handleChangeAutomatico}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                                }
                                label="Enviar email automático"
                            />
                      
                            <Button type="submit" variant="contained" color="primary">
                                SALVAR
                            </Button>
                        </form>
                    </fieldset>
                </main>
            </div>
        </>
    )
}